import { render } from "./Cover.vue?vue&type=template&id=39f009fa&scoped=true&bindings={\"element\":\"props\",\"show\":\"props\",\"cssStyle\":\"options\"}"
import script from "./Cover.vue?vue&type=script&lang=js"
export * from "./Cover.vue?vue&type=script&lang=js"

import "./Cover.vue?vue&type=style&index=0&id=39f009fa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-39f009fa"

export default script